import React from 'react';
import {
  Button,
  Copy,
  Flex,
  Heading,
  Image,
  Stack,
} from '@grubhubprod/gh-cookbook-react/dist';
import { useHistory } from 'react-router-dom';
import { Modal } from 'src/components/Modal/Modal';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';

const imageUrl =
  'https://res.cloudinary.com/grubhub-assets/image/upload/v1638979875/corp-management-ui/celebration-bag.svg';

export interface IEnterpriseWizardCompletionModalProps {
  corpId: string;
  onClose: () => void;
}

export function EnterpriseWizardCompletionModal({
  corpId,
  onClose,
}: IEnterpriseWizardCompletionModalProps): JSX.Element {
  const { push } = useHistory();
  const { redirectToHomePage } = useAuth();
  return (
    <Modal size="fluid" modalWidth="808px">
      <Flex>
        <Image src={imageUrl} alt="" role="presentation" />
        <Flex
          flexBasis="50%"
          justifyContent="center"
          alignItems="center"
          paddingLeft={16}
          paddingRight={16}
          flexDirection="column"
        >
          <Stack y="md">
            <Heading variant="h2">Congrats, you’re all set!</Heading>
          </Stack>
          <Stack y="md">
            <Copy display="block" variant="lead" textAlign="center">
              Create a meal credit to start feeding your employees.
            </Copy>
          </Stack>
          <Stack y="sm" width="100%">
            <Button
              variant="primary"
              buttonSize="medium"
              block
              onClick={() => {
                onClose();
                push(`/corporate/enterprise/${corpId}/meal-credits/create`);
              }}
            >
              Add meal credit
            </Button>
          </Stack>
          <Button
            variant="secondary"
            buttonSize="medium"
            block
            onClick={() => {
              onClose();
              redirectToHomePage(corpId);
            }}
          >
            Explore your account
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
